<ul class="nav nav-tabs justify-content-start">
  <li  class="nav-item" >
    <a class="nav-link" *ngIf="this.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV, TipoUsuario.SOPORTE)" routerLink="aerovalesIata" routerLinkActive="active"><b>Aerovales</b></a>
  </li>
  <li  class="nav-item" >
    <a class="nav-link" *ngIf="this.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV, TipoUsuario.SOPORTE)" routerLink="clientesIata" routerLinkActive="active"><b>Clientes</b></a>
  </li>

</ul>
<router-outlet></router-outlet>
